// FloatingLabelInput.jsx
import React, { useState } from 'react';
import { BASIC_CASES } from './Input';
const Textarea = ({ label, name, ...rest }) => {
  const [isFocused, setFocus] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const handleFocus = () => setFocus(true);
  const handleBlur = (e) => {
    setFocus(e.target.value !== '');
    setIsFilled(e.target.value !== '');
  };

  return (
    <div className="w-full ">
      <textarea
        id={name}
        name={name}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`${BASIC_CASES} ${
          isFocused ? '!border-primary-300 border-2' : ''
        } ${isFilled ? 'font-bold text-primary-700' : ''}`}
        placeholder={label}
        {...rest}
      ></textarea>
    </div>
  );
};

export default Textarea;
